interface IState {
    isOpen: boolean
}

const initialState: IState = {
    isOpen: false,
}

export const CHANGE_GLOBAL_MENU = 'CHANGE_GLOBAL_MENU'

function globalMenu(
    state: IState = initialState,
    action: { type: string; payload: boolean },
): IState {
    switch (action.type) {
        case CHANGE_GLOBAL_MENU:
            return {
                isOpen: action.payload,
            }
        default:
            return state
    }
}

export default globalMenu
